export default __webpack_public_path__ + "static/media/badge-level-1.92b26cf8.png";